/**
 * Helper to safely extract array validation state from form errors/touched
 * Validation state can be either a string (for the whole array) or an array of objects (per-item validation)
 * This helper ensures we only get the array format for per-item validation
 */
export const getArrayValidation = <T extends unknown[]>(
  value: T | string | boolean | undefined
): T | undefined => (Array.isArray(value) ? value : undefined)
